
import $ from "jquery";


function init() {
    const target = window.location.hash;
    if (target) {
        jumpTo(target);
    }
    $('a[href^="#"]').not('.submenu-trigger').on('click', function (e) {
        const href = $(this).attr('href');
        // Always suppress the native jump-to-top for in-page hash links
        // (e.g. placeholder href="#" logos/action links). jumpTo() no-ops
        // when the target can't be resolved, so missing targets just don't scroll.
        e.preventDefault();
        if (href !== '#') {
            jumpTo(href);
        }
    });
}

// Resolve a hash to its target element, falling back to legacy `<a name="...">`
// anchors since jQuery's `$('#id')` only matches by `id`, not `name`.
function resolveTarget(hash) {
    const id = hash.replace(/^#/, '');
    if (!id) {
        return $();
    }
    const $byId = $('#' + id);
    return $byId.length ? $byId : $('[name="' + id + '"]');
}

function jumpTo(hash) {
    const $target = resolveTarget(hash);
    if ($target.length) {
        const offset = $target.offset().top - $('header').outerHeight() - 80;
        window.location.hash = hash.replace('#', '');
        $(window).scrollTop(offset);
    }
}

export default init;